export const GROWTH_MONTHLY_REPORT_META = {
  eyebrow: 'Google Ads & SEO · Report',
  titleLead: 'Monthly',
  titleAccent: 'report',
  description:
    'Your marketing month in plain language — the ROI narrative, real booked patients, channel performance, and every action ELVA took while you focused on patients. Data verified via PMS integration and updated every hour.',
} as const;

// When >= 6, the revenue trend chart renders. Otherwise it is hidden.
export const MR_MONTHS_OF_DATA = 6;
